<template>
    <paper id="whCoverage" class="wh-coverage">
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :searchTotalTitle="searchTotalTitle"
            @saveData="saveData"
            @check-btn="checkBtn"
            @edit-btn="editBtn"
            @searchChange="searchChange"
            @selectChange="selectChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @element-change="elementChange"
            searchId="test"
            pageID="test"
        >
            <div slot="table-module-btn">
                <el-tooltip class="item" effect="dark" content="新增" placement="bottom">
                    <el-button size="mini" icon="el-icon-plus" @click="addData" v-has="'06380003'"></el-button>
                </el-tooltip>
                <reportExport #default="{ submit }" reportCode="REPORT_OTP_SUPERMARK_RULE">
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span v-has="'06380001'" class="mgl-10">
                        <el-button icon="icon-daochu" size="mini" @click="exportFile(submit)"></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
                <el-tooltip effect="dark" content="导入" placement="bottom">
                    <span v-has="'06380002'"  class="mgl-10">
                        <el-button icon="icon-daoru" size="mini" @click="orderImportC"></el-button>
                    </span>
                </el-tooltip>
            </div>
            <div slot="page-module-btn">
                <lots-button type="primary" @click="delData" v-has="'06380004'">删 除</lots-button>
                <lots-button type="primary" @click="saveData" v-has="'06380005'">保 存</lots-button>
            </div>
        </m-pane>
        <Import
            ref="Import"
            :ImportConfig="config.import.ImportConfig"
            :ImportContent="config.import.ImportContent"
            :templateTypes="config.import.templateTypes"
        ></Import>
    </paper>
</template>
<script>
import mPane from '@/components/otpPanel';
import config from './config';
import paper from '@/components/core/paper/Paper';
import { getScPosConfig, saveScPosConfig, delScPosConfig } from '@otp/api/superMarketMark';
import lotsButton from '@/components/lots/lotsButton';
import reportExport from '@/components/lots/reportExportPlugin';
import { mapState } from 'vuex';
import Import from '../../orderManage/orderCenter/order/Import.vue';
export default {
    name: 'superMarketMark',
    components: { mPane, paper, lotsButton, reportExport, Import },
    data() {
        return {
            config: config,
            loading: false,
            totalData: [],
            pageTotal: 0,
            searchTotalTitle: config.searchTotalTitle,
            visible: false,
            dialog: config.dialog,
            searchParams: {
                pageSize: 10,
                pageNo: 1,
                orderByType: 'Desc',
                orderBy: 'create_time'
            },
            selectedRows: []
        };
    },
    computed: {
        ...mapState({
            currentTenant: state => state.currentTenant
        })
    },
    methods: {
        orderImportC() {
            this.$refs.Import.orderImportC();
        },
        // 导出
        exportFile(submit) {
            if (!this.searchParams.siteCode) {
                return this.$message.warning('服务平台必填');
            }
            submit({
                ...this.searchParams
            });
        },

        deleteNullSearchParams(searchParams) {
            for (const key in searchParams) {
                if (!searchParams[key] && searchParams[key] !== 0) {
                    delete searchParams[key];
                }
            }
        },
        getList(toFirstPage) {
            if (toFirstPage) {
                this.$refs.tablePage.$refs.searchList.onSearchChange();
                return;
            }
            const params = Object.assign({}, this.searchParams);
            this.deleteNullSearchParams(params);
            getScPosConfig(params).then(res => {
                if (res && +res.code === 0) {
                    this.totalData = res.data.list.map(item => {
                        if (item.provinceCode && item.cityCode) {
                            item.address = [
                                item.provinceCode,
                                item.cityCode,
                                item.districtCode,
                                item.townCode
                            ].filter(r => r);
                            item.addressCn = [
                                item.provinceName,
                                item.cityName,
                                item.districtName,
                                item.townName
                            ].filter(r => r).join('/');
                        } else {
                            item.address = [];
                        }

                        // 聚合操作人和编码
                        const combine = (name, code) => {
                            return name + (code ? ('(' + code + ')') : '');
                        };
                        item.createUserNameAndCode = combine(item.createUserName, item.createUserCode);
                        item.updateUserNameAndCode = combine(item.updateUserName, item.updateUserCode);

                        return item;
                    });
                    this.pageTotal = res.data.totalCount;
                }
            });
        },
        checkBtn(data) {
            // 表格内按钮查看事件;
            this.visible = true;
        },
        editBtn(data) {
            // 表格内按钮修改事件;
        },
        selectChange(data) {
            // 表格内选择变化
            this.selectedRows = data;
        },
        searchChange(data) {
            // 提交搜索框
            this.searchParams = { ...this.searchParams, ...data };
            this.searchParams.pageNo = 1;
            this.getList();
        },
        pageChange(data) {
            // 分页器页数变化
            this.searchParams.pageNo = data;
            this.getList();
        },
        sizeChange(data) {
            // 分页器页数大小变化
            this.searchParams.pageSize = data;
            this.getList();
        },
        addData() {
            // 表格新增方法
            this.$refs.tablePage.$refs.table.addRow();
            this.$message.warning('请确保详细地址与订单上地址一致');
        },
        elementChange(data) {
        },
        saveData(data) {
            // 表格新增修改后返回数据 table 校验
            let params = this.$refs.tablePage.$refs.table.$refs.mNewTable.saveData();
            if (params.length === 0) {
                this.$message.warning('请至少选择一条数据');
                return;
            }
            if (!params) {
                return;
            }
            params = params.map(item => {
                // 暂时取消四级地址 by 高露
                // item.addressCn = item.addressCn.replace(/\s/g, '').split('/');
                // item = {
                //     ...item,
                //     ...setAddressConfig(item.address, ['provinceCode', 'cityCode', 'districtCode', 'townCode']),
                //     ...setAddressConfig(item.addressCn, ['provinceName', 'cityName', 'districtName', 'townName'])
                // };
                // Reflect.deleteProperty(item, 'address');
                // Reflect.deleteProperty(item, 'addressCn');

                // 删除会更改的字段
                Reflect.deleteProperty(item, 'updateTime');
                Reflect.deleteProperty(item, 'createTime');
                Reflect.deleteProperty(item, 'updateUserCode');
                Reflect.deleteProperty(item, 'createUserCode');
                Reflect.deleteProperty(item, 'updateUserName');
                Reflect.deleteProperty(item, 'createUserName');

                return item;
            });

            saveScPosConfig(params).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('操作成功');
                    this.getList(true);
                }
            });
        },
        delData() {
            if (this.checkSelectRow()) return;
            const data = this.selectedRows.map(item => {
                return item.id;
            });
            delScPosConfig(data).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('删除成功');
                    this.getList(true);
                }
            });
        },
        checkSelectRow() {
            if (!this.selectedRows.length) {
                this.$message.warning('请选择数据');
                return true;
            }
        }
    },
    async mounted() {
        this.getList();
    }
};
</script>
<style lang="less">
.wh-coverage {
    .m-address-cascader {
        width: 100%;
    }
}

</style>
